import { logErrorIfNotWebApiRequestCancellation } from "@faire/deprecated-retailer-visitor-shared/lib/logErrorIfNotWebApiRequestCancellation";
import { useLoggedOutSuppliersPageError } from "@faire/deprecated-retailer-visitor-shared/views/suppliers/__internal__/LazySuppliersPage/__internal__/SuppliersPage/__internal__/DataFetching/BrandsSearch/useLoggedOutSuppliersPageError";
import { useLoggedOutSuppliersPageIsError } from "@faire/deprecated-retailer-visitor-shared/views/suppliers/__internal__/LazySuppliersPage/__internal__/SuppliersPage/__internal__/DataFetching/BrandsSearch/useLoggedOutSuppliersPageIsError";
import { useEffect } from "react";

export const LoggedOutSuppliersPageLogErrorEffect = () => {
  const isError = useLoggedOutSuppliersPageIsError();
  const error = useLoggedOutSuppliersPageError();

  useEffect(() => {
    if (isError) {
      logErrorIfNotWebApiRequestCancellation(error);
    }
  }, [error, isError]);

  return null;
};
